import { RefObject, useEffect } from "react";

export const centerOnZoom = (scrollRef: RefObject<HTMLDivElement>, zoom: number, editTable: number | null) =>
  useEffect(() => {
    const { current } = scrollRef;
    if (!current) {
      return;
    }
    if (current.scrollTo) {
      current.scrollTo((current.scrollWidth - current.clientWidth) / 2, 0);
    }
  }, [zoom, editTable]);
